import React from "react";
import PropTypes from "prop-types";

const ResetButton = ({ onReset }) => (
  <div className="reset-button-wrapper" title="Reset">
    <button onClick={() => onReset()} className="reset-button">
      Reset
    </button>
  </div>
);

ResetButton.propTypes = {
  onReset: PropTypes.func.isRequired,
};

export default ResetButton;
